import { render, staticRenderFns } from "./BaseTransactionDetails.vue?vue&type=template&id=0a6bb03a&"
import script from "./BaseTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./BaseTransactionDetails.vue?vue&type=script&lang=js&"
import style0 from "./BaseTransactionDetails.vue?vue&type=style&index=0&id=0a6bb03a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports